(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.js-nav-trigger--secondary').forEach((trigger) => {
    trigger.addEventListener('click', function () {
      const menuKey = this.dataset.menu;
      const panel = document.querySelector(`.js-nav-section[data-menu="${menuKey}"]`);

      // Reset aria-expanded on all triggers
      document.querySelectorAll('.js-nav-trigger--secondary').forEach((t) => {
        t.setAttribute('aria-expanded', 'false');
      });
      this.setAttribute('aria-expanded', 'true');

      // Show only the selected panel
      document.querySelectorAll('.js-nav-section').forEach((p) => {
        p.classList.remove('is-active');
      });
      panel?.classList.add('is-active');

      // Wait for the panel to render, then focus
      requestAnimationFrame(() => {
        const firstLink = panel?.querySelector('a[href]');
        if (firstLink) {
          firstLink.setAttribute('tabindex', '-1');
          firstLink.focus();
        } else if (panel) {
          panel.setAttribute('tabindex', '-1');
          panel.focus();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-fragrance"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.js-pdp-swiper', {
    lazy: true,
    preloadImages: false,
    watchSlidesVisibility: true,
    on: {
      slideChange: function() {
        var activeSlide = swiper.slides[swiper.activeIndex];
        var video = activeSlide.querySelector('video');
        if (video) video.play();
      }
    }
  });

  function initKlaviyoBackInStock() {
    var klaviyo = klaviyo || [];
    klaviyo.init({ account: "Kz4LBR", platform: "shopify" });
    klaviyo.enable("backinstock", {
      modal: {
        headline: "{product_name}",
        body_content: "Register to receive a notification when this item comes back in stock.",
        email_field_label: "Email",
        button_label: "Notify me when available",
        subscription_success_label: "You're in! We'll let you know when it's back.",
        footer_content: '',
        additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
        drop_background_color: "#000", background_color: "#fff", text_color: "#222",
        button_text_color: "#fff", button_background_color: "#141414",
        close_button_color: "#ccc", error_background_color: "#fcd6d7",
        error_text_color: "#C72E2F", success_background_color: "#d3efcd",
        success_text_color: "#1B9500"
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.js-pdp-swiper', {
    lazy: true,
    preloadImages: false,
    watchSlidesVisibility: true,
    on: {
      slideChange: function () {
        var activeSlide = swiper.slides[swiper.activeIndex];
        var video = activeSlide.querySelector('video');
        if (video) video.play();
      },
      slideTransitionEnd: function () {
        var activeSlide = swiper.slides[swiper.activeIndex];
        var video = activeSlide.querySelector('video');
        if (video && !video.paused) video.play();
      },
    },
  });

  var klaviyo = klaviyo || [];

  function initKlaviyoBackInStock() {
    klaviyo.init({ account: 'Kz4LBR', platform: 'shopify' });
    klaviyo.enable('backinstock', {
      modal: {
        headline: '{product_name}',
        body_content: 'Register to receive a notification when this item comes back in stock.',
        email_field_label: 'Email',
        button_label: 'Notify me when available',
        subscription_success_label: "You're in! We'll let you know when it's back.",
        footer_content: '',
        additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
        drop_background_color: '#000',
        background_color: '#fff',
        text_color: '#222',
        button_text_color: '#fff',
        button_background_color: '#141414',
        close_button_color: '#ccc',
        error_background_color: '#fcd6d7',
        error_text_color: '#C72E2F',
        success_background_color: '#d3efcd',
        success_text_color: '#1B9500',
      },
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-preloader]").forEach(preloader => {
      const section = preloader.nextElementSibling;
      window.requestAnimationFrame(() => {
        preloader.style.display = "none";
        section.classList.remove("is-hidden");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu"]) return;
  try {
    


  var slug = document.getElementById('location-menu').dataset.slug;
  var theQuery = `query {
    barMenuCollection(where: {
          slug: "${slug}"
      }, 
      limit: 1) {
          items {
          sectionsCollection {
                  items {
                      ... on CocktailSection {
                          navigationTitle
                          title                          
                          itemsCollection {
                              items {
                                  title:title
                                  text
                                  price
                              }
                          }
                          
                      }
                      ... on MenuSection {
                          title
                          subtitle
                          itemsCollection {
                              items {
                                  title
                                  text
                                  price
                                  number
                              }
                          }
                      }
                      ... on FeaturedContent {
                          title
                          callout
                          photo {
                              url
                          }
                      }
                      ... on VideoSection {
                          title
                          callout
                          video {
                              url
                          }
                      }
                  }
              }
          }
      }
  }`;
  
  var graphQlEndpoint = "https://graphql.contentful.com/content/v1/spaces/zytxxfc2fpnt/environments/master";

  var graphQlHeaders = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ny6VBV68f0S6v4FZWkkGCs2cSm3qcoekY95WnX6TRBY'
  }

  var locationMenu = new Vue({
    el: '#location-menu',
    delimiters: ['<%', '%>'],
    data() {
      return {
        items: []
      }
    },
    mounted() {
      //this.getEntries()
      //this.doGraphQl()
      this.getData()
      this.fixnav()
    },
    methods: {
      fixnav() {
        
          $(window).on('scroll', function(){
            //if( $(window).width() < 640 ) {
              var o = $('.tabs-wrapper').offset().top
              var headerHeight = $('.header').height()
              console.log(o,window.scrollY)
              if (window.scrollY > o - headerHeight) {
                $('body').addClass('tabs-fixed')
                $('.tabs').css({'top': `${headerHeight}px`})
              }
              else {
                $('body').removeClass('tabs-fixed')
                $('.tabs').css({'top': 'auto'})
              }  
            //}//end 640  
          })
       
      },
      toggleClass(e) {
        $('.js-tab-label').removeClass('active')
        $(e.target).addClass('active')
        var dataIndex = $(e.target).data('index')
        console.log(e.target, dataIndex)
        var allTabs = $('.js-tab-content')
        var allPills = $('.js-pill')
        var activePill = $(`.js-pill[data-index="${dataIndex}"]`)
        var activeTab = $(`.js-tab-content[data-index="${dataIndex}"]`)
        allPills.removeClass('active')
        allTabs.removeClass('active')
        activeTab.addClass('active')
        activePill.addClass('active')



        //get the full url - like mysitecom/index.htm#home
        var baseUrl = window.location.href.split("#")[0]
        var full_url = baseUrl+`#${dataIndex}`;
        console.log(full_url)

        // //split the url by # and get the anchor target name - home in mysitecom/index.htm#home
        var parts = full_url.split("#");
        var trgt = parts[1];

        // //get the top offset of the target anchor
        var target_offset = $(`#tab-${dataIndex}`).offset();
        var target_top = target_offset.top;

        console.log(dataIndex, target_offset,target_top)

        // //goto that anchor by setting the body scroll top to anchor top
        $('html, body').animate({scrollTop:target_top - 120}, 300);
      

      },
      getData() {
        fetch(graphQlEndpoint, {
          method: 'POST',
          headers: graphQlHeaders,
          body: JSON.stringify({
            query: theQuery
          })
        })
        .then((res) => res.json())
        .then((result) => {
          this.items = result.data.barMenuCollection.items[0].sectionsCollection.items
          console.log(JSON.stringify(result))         
        });
                      
      }
    }
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-loyalty-earning-points"] && !Shopify.designMode) return;
  try {
    
function addSwiperClasses () {
  $('.yotpo-widget-campaign-widget-container').addClass('swiper');
  $('.yotpo-widget-campaign-widget-container [role="list"]').addClass('swiper-wrapper');
  $('.yotpo-widget-campaign-widget-container [role="listitem"]').addClass('swiper-slide');
}

function initializeSwiper () {
  addSwiperClasses();

  $('.yotpo-widget-campaign-widget-container').append('<button class="swiper-button-next"></button>');
  $('.yotpo-widget-campaign-widget-container').append('<button class="swiper-button-prev"></button>');

  var swiper = new Swiper('.swiper', {
    slidesPerView: 1,
    spaceBetween: 14,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768 : {
        slidesPerView: 4,
        spaceBetween: 24
      }
    }
  });

  return swiper;
}

/* document.addEventListener('DOMContentLoaded', function() {
  $(document).on('swell:setup swell:initialized', function() {
    var swiper = initializeSwiper();
    swiper.on('resize', function () {
      addSwiperClasses();
      swiper.update();
    });
  });
}); */  

  } catch(e) { console.error(e); }
})();
})();
